<template>
    <div>
        <div v-if="loading" class="mt-5 mb-5">
            <spinner position="center"></spinner>
        </div>
        <form v-if="client" v-show="!loading" id="propertyForm" ref="propertyForm" method="POST"
              class="ang-card-body"
              :action="action">
            <input name="finished" value="1" type="hidden"/>
            <input type="hidden" name="code" :value="code" />
            <input type="hidden" name="data[step_5]" value="1" />
            <input v-if="!client.data.properties || client.data.properties.length === 0 || !client.data.properties[0]" type="hidden" name="data[properties][]" />
            <div v-if="client.data.properties && client.data.properties[0]">
                <div  v-for="(e, i) in client.data.properties" :key="'properties_' + i">
                    <div class="row" >
                        <div class="col-12 d-flex">
                            <div class="ang-card-title mt-3">Nieruchomość<span class="ml-2" v-if="client.data.properties.length > 1">({{i+1}})</span></div><div class="ml-auto" v-if="i > 0"><button class="mt-3 btn btn-lg  ang-button _bg_color2" @click.stop.prevent="removeProperty(i)">Usuń</button></div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="ang-form-label">Zastosowanie</label>
                                <div class="form-check">
                                    <input type="hidden" :value="0" :name="'data[properties][' + i + '][type_credit]'">
                                    <input class="form-check-input " type="checkbox" :value="1" :name="'data[properties][' + i + '][type_credit]'" :id="'data[properties][' + i + '][type_credit]'" @change="el => e.type_credit = el.target.checked" :checked="e.type_credit === '1' || e.type_credit === true">
                                    <label class="form-check-label" :for="'data[properties][' + i + '][type_credit]'" style="margin-top: 3px">
                                        Przedmiot kredytowania
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input type="hidden" :value="0" :name="'data[properties][' + i + '][type_secure]'" >
                                    <input class="form-check-input " type="checkbox" :value="1" :name="'data[properties][' + i + '][type_secure]'" :id="'data[properties][' + i + '][type_secure]'" @change="el => e.type_secure = el.target.checked" :checked="e.type_secure === '1' || e.type_secure === true">
                                    <label class="form-check-label" :for="'data[properties][' + i + '][type_secure]'" style="margin-top: 3px">
                                        Przedmiot zabezpieczenia
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-2">
                          <div class="form-group">
                            <label class="ang-form-label">Rodzaj nieruchomości</label>
                            <select-field :name="'data[properties][' + i + '][property_type]'" css="width: 100%" :options="{values: [{val: 'dom', text: 'Dom'}, {val: 'mieszkanie', text: 'Mieszkanie'}]}"
                                          placeholder="Wybierz" v-model="e.property_type" :selected="e.property_type" @changed="refreshForm"></select-field>
                          </div>
                        </div>
<!--                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label class="ang-form-label">Ulica</label>
                                <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][street]'"
                                       v-model="e.street">
                            </div>
                        </div>
                        <div class="col-6 col-md-2">
                            <div class="form-group">
                                <label class="ang-form-label">Nr budynku</label>
                                <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][number]'"
                                       v-model="e.number">
                            </div>
                        </div>
                        <div class="col-6 col-md-2">
                            <div class="form-group">
                                <label class="ang-form-label">Nr lokalu</label>
                                <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][flat]'"
                                       v-model="e.flat">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label class="ang-form-label">Kod pocztowy</label>
                                <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][postal]'"
                                        v-model="e.postal">
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label class="ang-form-label">Miasto</label>
                                <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][city]'"
                                       v-model="e.city">
                            </div>
                        </div>-->

                          <div class="col-12 col-md-2">
                            <div class="form-group">
                              <label class="ang-form-label">Kod pocztowy</label>
                              <input type="text" class="postal ang-form-control" :name="'data[properties][' + i + '][postal]'"
                                     v-model="e.postal" @keyup="getAddress($event.target.value, 'properties', i, e)">
                            </div>
                          </div>
                          <div class="col-12 col-md-4">
                            <div class="form-group">
                              <label class="ang-form-label">Ulica</label>
                              <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][street]'"
                                     v-model="e.street">
                            </div>
                          </div>
                          <div class="col-6 col-md-2">
                            <div class="form-group">
                              <label class="ang-form-label">Nr budynku</label>
                              <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][number]'"
                                     v-model="e.number">
                            </div>
                          </div>
                          <div class="col-6 col-md-2">
                            <div class="form-group">
                              <label class="ang-form-label" >Nr lokalu</label>
                              <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][flat]'"
                                     v-model="e.flat">
                            </div>
                          </div>
                          <div class="col-12 col-md-4">
                            <div class="form-group">
                              <label class="ang-form-label">Miasto</label>
                              <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][city]'"
                                     v-model="e.city">
                            </div>
                          </div>
                          <div class="col-12 col-md-4">
                            <div class="form-group">
                              <label class="ang-form-label">Gmina</label>
                              <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][commune]'"
                                     v-model="e.commune">
                            </div>
                          </div>
                          <div class="col-12 col-md-4">
                            <div class="form-group">
                              <label class="ang-form-label">Powiat</label>
                              <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][county]'"
                                     v-model="e.county">
                            </div>
                          </div>
                          <div class="col-12 col-md-4">
                            <div class="form-group">
                              <label class="ang-form-label">Województwo</label>
                              <select-field :name="'data[properties][' + i + '][province]'" css="width: 100%" :options="dictionary.provinces" @changed="refreshForm"
                                            v-model="e.province" :selected="e.province"></select-field>
                            </div>
                          </div>

                      <div class="col-12 col-md-2">
                        <div class="form-group">
                          <label class="ang-form-label">Pow. użytkowa lokalu m<sup>2</sup></label>
                          <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][residential_area]'"  v-model="e.residential_area">
                        </div>
                      </div>
                      <div class="col-12 col-md-2">
                        <div class="form-group">
                          <label class="ang-form-label">Powierzchnia działki m<sup>2</sup></label>
                          <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][plot_area]'"  v-model="e.plot_area">
                        </div>
                      </div>
                        <div class="col-12 col-md-2">
                          <div class="form-group">
                            <label class="ang-form-label">Liczba pokoi</label>
                            <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][rooms]'"  v-model="e.rooms">
                          </div>
                        </div>
                      <div class="col-12 col-md-2">
                        <div class="form-group">
                          <label class="ang-form-label" >Deklarowana wartość</label>
                          <currency-field :name="'data[properties][' + i + '][value]'" :notrequired="true"
                                          v-model="e.value"></currency-field>
                        </div>
                      </div>
                    </div>
                    <div class="row align-items-end">
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label class="ang-form-label">Nr ewidencyjny działki</label>
                                <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][identifier]'"
                                        v-model="e.identifier">
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label class="ang-form-label">Parametry nieruchomości</label>
                                <select-field css="width: 100%" :name="'data[properties][' + i + '][property_parameters]'" @changed="refreshForm"
                                              :options="dictionary.propertyParameters" placeholder="Wybierz" v-model="e.property_parameters" :selected="e.property_parameters"></select-field>
                            </div>
                        </div>
                      <div class="col-12 col-md-4">
                        <div class="form-group">
                          <label class="ang-form-label">Księga wieczysta</label>
                          <select-field :name="'data[properties][' + i + '][mortgage_register]'" css="width: 100%" @changed="refreshForm"
                                        :options="{values: [{val: 'Tak', text: 'Tak'}, {val: 'Nie', text: 'Nie'}]}" placeholder="Wybierz"
                                        v-model="e.mortgage_register" :selected="e.mortgage_register"></select-field>
                        </div>
                      </div>
<!--                     Tyylko dla ing  \/ -->
                      <div class="col-12 col-md-4">
                        <div class="form-group">
                          <label class="ang-form-label">Forma własności domu / lokalu / miejsca postojowego / garażu</label>
                          <select-field  css="width: 100%" :name="'data[properties][' + i + '][ownership]'" @changed="refreshForm"
                                        :options="dictionary.ownership" placeholder="Wybierz" v-model="e.ownership" :selected="e.ownership"></select-field>
                        </div>
                      </div>
                        <div class="col-12 col-md-4" v-if="e.mortgage_register === 'Tak'">
                            <div class="form-group">
                                <label class="ang-form-label" >Nr KW</label>
                                <input type="text" class="ang-form-control kw" :name="'data[properties][' + i + '][mortgage_register_number]'"
                                        v-model="e.mortgage_register_number" @input="updateMortgageCourt(e)">
                            </div>
                        </div>
                        <div class="col-12 col-md-4" v-if="e.mortgage_register === 'Tak'">
                            <div class="form-group">
                                <label class="ang-form-label" >Sąd prowadzący KW</label>
                                <input type="text" class="ang-form-control" :name="'data[properties][' + i + '][mortgage_register_court]'"
                                        v-model="e.mortgage_register_court">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="alert alert-danger ang-alert-danger mt-3" v-if="error">
                <h5 class="ang-card-title">Wystąpił błąd!</h5>
                <label class="form-error error">{{error}}</label>
            </div>
            <div class="d-flex">
                <div>
                    <button class="btn ang-button _bg_color3 mt-1" @click.stop.prevent="$emit('backward')">Wstecz</button>
                </div>
                <div class="ml-auto">
                    <spinner v-if="sending"></spinner>
                    <div v-else>
                        <button class="btn btn-lg  ang-button _bg_color2  spinn mr-2" @click.stop.prevent="addProperty">Dodaj kolejną nieruchomość</button>
                        <button type="submit" @click.stop.prevent="checkForm" class="btn btn-lg  ang-button ang-btn-lg spinn">Dalej</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import ajax from '@/services/ajax'
// import api from '@/services/api'
import spinner from "@/components/partials/misc/spinner"
import select from "@/components/partials/misc/select"
import currency from "@/components/partials/misc/currency"
import $ from 'jquery'
import dictionary from "@/services/dictionary"
import api from "@/services/api";
import helper from "@/services/helper";

let courts = require('@/resources/courts.json');

export default {
  data () {
    return {
      success: false,
      error: null,
      sending: false,
      atLeastOneError: '',
      loading: true,
      client: null,
      courts
    }
  },
  props: ['base_client', 'base', 'code'],
  components: {
    spinner,
    'select-field': select,
    'currency-field': currency
  },
  mixins: [dictionary],
  watch: {
    base_client () {
      let self = this
      this.client = this.base_client
      if (typeof this.client.data.properties === 'undefined') {
        this.client.data.properties = [{}]
      }
      this.$nextTick(function () {
        self.loading = false
      })
    }
  },
  name: 'propertyForm',
  computed: {
    action () {
      return '/client/details/' + this.base
    }
  },
  mounted () {
    let self = this

    this.client = this.base_client
    if (typeof this.client.data.properties === 'undefined') {
      this.client.data.properties = [{}]
    }
    this.$nextTick(function () {
      self.loading = false
      helper.maskPostal()
      ajax.postValidate($(self.$refs.propertyForm), self, function (form, vm, data) {
        self.sending = false
        self.$emit('forward', data)
      }, function (data) {
        self.error = data.message
        self.sending = false
        $('html,body').animate({scrollTop: $(document).height()}, 'slow')
      }, function () {
        self.error = null
        self.sending = true
      })
    })
  },
  methods: {
    getAddress (postal, addresType, index) {
      let self = this
      let regex = new RegExp('^[0-9]{2}-[0-9]{3}$')
      if (regex.test(postal)) {
        api.get('/address/' + postal, {}, function (data) {
          if (data.length === 1) {
            self.client.data[addresType][index]['commune'] = data[0].gmina
            self.client.data[addresType][index]['county'] = data[0].powiat
            self.client.data[addresType][index]['city'] = data[0].miejscowosc
            self.client.data[addresType][index]['post_office'] = data[0].miejscowosc
            self.client.data[addresType][index]['street'] = data[0].ulica
            $('select[name="data[' + addresType + '][' + index + '][province]"]').val(data[0].wojewodztwo)
            $('select[name="data[' + addresType + '][' + index + '][province]"]').change()
            self.$forceUpdate()
          } else {
            let tmp_ar = data.filter(function( obj ) {
              return obj.wojewodztwo !== data[0].wojewodztwo
            })
            if (tmp_ar.length === 0) {
              $('select[name="data[' + addresType + '][' + index + '][province]"]').val(data[0].wojewodztwo)
              $('select[name="data[' + addresType + '][' + index + '][province]"]').change()
              tmp_ar = data.filter(function( obj ) {
                return obj.powiat !== data[0].powiat
              })
            } else {
              $('select[name="data[' + addresType + '][' + index + '][province]"]').val('')
              $('select[name="data[' + addresType + '][' + index + '][province]"]').change()
            }

            if (tmp_ar.length === 0) {
              self.client.data[addresType][index]['county'] = data[0].powiat
              tmp_ar = data.filter(function( obj ) {
                return obj.gmina !== data[0].gmina
              })
            } else {
              self.client.data[addresType][index]['county'] = ''
            }

            if (tmp_ar.length === 0) {
              self.client.data[addresType][index]['commune'] = data[0].gmina
              tmp_ar = data.filter(function( obj ) {
                return obj.miejscowosc !== data[0].miejscowosc
              })
            } else {
              self.client.data[addresType][index]['commune'] = ''
            }

            if (tmp_ar.length === 0) {
              self.client.data[addresType][index]['city'] = data[0].miejscowosc
              self.client.data[addresType][index]['post_office'] = data[0].miejscowosc
              tmp_ar = data.filter(function( obj ) {
                return obj.ulica !== data[0].ulica
              })
            } else {
              self.client.data[addresType][index]['city'] = ''
              self.client.data[addresType][index]['post_office'] = ''
            }

            if (tmp_ar.length === 0) {
              self.client.data[addresType][index]['street'] = data[0].ulica
            } else {
              self.client.data[addresType][index]['street'] = ''
            }

            self.$forceUpdate()
          }
        })
      }
    },
    checkForm () {
      let self = this
      // if ($(".atLeastOne:checkbox:checked").length === 0) {
      //   this.atLeastOneError = 'Musisz wybrać przynajmniej jedną opcję.'
      // } else {
      //   this.atLeastOneError = ''
      //   $(self.$refs.propertyForm).submit()
      // }
      $(self.$refs.propertyForm).submit()
    },
    addProperty () {
      this.client.data.properties.push({})
      this.$forceUpdate()
    },
    removeProperty (i) {
      this.client.data.properties.splice(i, 1)
      this.$forceUpdate()
    },
    refreshForm () {
      this.$forceUpdate()
    },
    scrollToAnchor (aid) {
      let aTag = $("#" + aid)
      if (typeof aTag !== 'undefined' && typeof aTag.offset() !== 'undefined') {
        $('html,body').animate({scrollTop: aTag.offset().top - 160}, 'slow')
      }
    },
    updateMortgageCourt (property) {
      if (property.mortgage_register_court === undefined) {
        this.$set(property, 'mortgage_register_court', '')
      }

      let founded = this.findCourt(this.courts, property.mortgage_register_number);
      if (founded) property.mortgage_register_court = founded.sad_nazwa
    },
    findCourt (courts, text) {
      return courts.find(court => text.toUpperCase().indexOf(court.sad_rejonowy_wydzial_kw_kod) !== -1 ? court : null)
    }
  }

}
</script>

